var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 64,
    fill: "#00C805"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36 78c18-2 34-10 46-24 8-9 13-20 15-32-14 8-25 20-32 34-4 8-7 16-8 25-7-1-14-2-21-3zm10 8c1-10 4-19 9-28 8-15 20-27 35-36 1 14-3 27-12 38-10 13-22 22-32 26z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobin);
export default __webpack_public_path__ + "static/media/robin.34b3211cfa62568fe01e0aba8b3f8b07.svg";
export { ForwardRef as ReactComponent };